export function getCurrentDocHeight() {
  return document.body.clientHeight;
}
